import { useEffect, useState } from 'react';

/**
 * @desc: Хук для получения разрешения экрана
 * @author: https://usehooks.com/useWindowSize/
 * @deprecated
 * @returns { {width, height} | object}
 */

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
